module.exports = __webpack_public_path__ + "static/img/BU02-5.c336b70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU02-5.jpg
// module id = ezJe
// module chunks = 1